module.exports = __webpack_public_path__ + "static/img/icon_yzglpt.901ce672.png";